export default {
    select: {
        all: 'All',
        noOption: 'No options.',
        noResults: 'No result.',
        selected: 'selected',
    },
};
